import { Component } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { Router, NavigationStart } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import {
  PaymentHistory,
  RequestFullTaxPayload,
} from '../../../../../core/models/payment.model';
import { StatusAPIResponseMain } from '../../../../../core/models/information.model';
import { MyAddressAllResponse } from '../../../../../core/models/user.model';
import { PaymentHistoryService } from '../../../../../services/payment-history.service';
import { Subscription } from 'rxjs';
import { forkJoin } from 'rxjs';
import { LanguageService } from '../../../../../core/services/language.service';
import { PssLoadingComponent } from '../../../../../tools/template/pss/pss-loading/pss-loading.component';
import { ToastWarnComponent } from '../../../../../tools/template/toast/toast-warn/toast-warn.component';
import { ToastFailedComponent } from '../../../../../tools/template/toast/toast-failed/toast-failed.component';
import { ToastSuccessComponent } from '../../../../../tools/template/toast/toast-success/toast-success.component';
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { InputComponent } from '../../../../../tools/forms/input/input.component';
import { ModalConfirmComponent } from '../../../../../tools/modals/modal-confirm/modal-confirm.component';
import { ModalTemplateComponent } from '../../../../../tools/modals/modal-template/modal-template.component';
import { ModalTemplate2Component } from '../../../../../tools/modals/modal-template-2/modal-template-2.component';
import { ApiMemberService } from '../../../../../core/services/api/Member/api-member';
import { ApiPaymentService } from '../../../../../core/services/api/Payment/api-payment';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatMomentDateModule,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-payment-history-2',
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatMomentDateModule,
    PssLoadingComponent,
    ModalTemplate2Component,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  templateUrl: './payment-history-2.component.html',
  styleUrl: './payment-history-2.component.css',
})
export class PaymentHistory2Component {
  currentLang: 'TH' | 'EN' = 'TH';
  sub!: Subscription;
  token: string = '';
  uid: string = '';
  startDate: Moment | null = null;
  endDate: Moment | null = null;
  old_startDate: string = '';
  old_endDate: string = '';
  myCards: any[] = [];
  isLoading = false;
  disabledFulltax: boolean = false;
  isSaveLoading: boolean = false;
  today: Date = new Date();
  minStartDate: Date = new Date();
  payment_history: PaymentHistory[] = [];
  selectedPayment: PaymentHistory | null = null;
  showModal_option: boolean = false;
  showTaxModal: boolean = false;

  // Advanced UI Controls State
  showDashboard: boolean = true;
  showTableFilters: boolean = false;
  searchQuery: string = '';
  selectedSite: string = '';
  selectedFeeType: string = '';
  searchFieldText: string = '';
  isSiteDropdownOpen: boolean = false;
  statusOpenDetails: string = '';

  mainOffice: boolean = false;
  selectedTaxType: string = '1';
  selectedColor: string | null = null;
  tambons: any[] = [];
  amphures: any[] = [];
  provincess: any[] = [];
  selectedAddress: MyAddressAllResponse | null = null;
  showAddressModal: boolean = false;
  showSelectAddress: boolean = false;
  addressListAll: MyAddressAllResponse[] = [];
  filteredAddressList: MyAddressAllResponse[] = [];
  address_id: number = 0;
  showModal_confirm: boolean = false;
  zipcode: string = '';
  selectedAmphure: any = null;
  selectedProvinces: any = null;
  selectedTambonId: number | null = null;
  selectedProvinceId: number | null = null;
  selectedAmphureId: number | null = null;
  filteredAmphures: any[] = [];
  filteredTambons: any[] = [];
  originalDate: Date | null = null;
  disabled: boolean = true;
  branchName: string = '';
  branchNo: string = '';
  submit: boolean = false;
  userStatus: boolean = false;
  taxName: string = '';
  taxId: string = '';
  address: string = '';
  province_name: string | null = null;
  amphure_name: string | null = null;
  tambon_name: string | null = null;
  email: string = '';
  tax_phone: string = '';
  private routeSub!: Subscription;

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false;
  textWarn: string = '';
  detailWarn: string = '';
  isError: boolean = false;
  textError: string = '';
  detailError: string = '';

  activeDropdown: 'province' | 'amphure' | 'tambon' | null = null;
  provinceSearchText: string = '';
  amphureSearchText: string = '';
  tambonSearchText: string = '';

  // ================= Getters =================

  /**
   * Returns the filtered list of payment history records based on search query, site, and payment type.
   */
  get filteredPaymentHistory(): PaymentHistory[] {
    let list = this.payment_history || [];

    // License Plate Search
    if (this.searchQuery && this.searchQuery.trim() !== '') {
      const q = this.searchQuery.toLowerCase().trim();
      list = list.filter(item =>
        (item.lincense && item.lincense.toLowerCase().includes(q)) ||
        (item.receiptId && item.receiptId.toLowerCase().includes(q))
      );
    }

    // Site Name Filter
    if (this.selectedSite && this.selectedSite.trim() !== '') {
      list = list.filter(item => item.siteName === this.selectedSite);
    }

    // Fee Type Name Filter (Payment Type)
    if (this.selectedFeeType && this.selectedFeeType.trim() !== '') {
      list = list.filter(item => item.feeTypeName === this.selectedFeeType);
    }

    return list;
  }

  /**
   * Returns the total number of payments in the filtered payment history.
   */
  get totalPayments(): number {
    return this.filteredPaymentHistory.length;
  }

  /**
   * Returns the total paid amount of the filtered list.
   */
  get totalAmount(): number {
    return this.filteredPaymentHistory.reduce((sum, item) => sum + (item.total || 0), 0);
  }

  /**
   * Returns the filtered list of provinces for custom select dropdown based on search query.
   */
  get filteredProvincess() {
    const text = (this.provinceSearchText || '').trim().toLowerCase();
    if (!text) return this.provincess || [];
    return (this.provincess || []).filter(p => p?.name_th?.toLowerCase().includes(text));
  }

  /**
   * Returns the filtered list of amphures for custom select dropdown based on search query.
   */
  get filteredAmphureOptions() {
    const text = (this.amphureSearchText || '').trim().toLowerCase();
    if (!text) return this.filteredAmphures || [];
    return (this.filteredAmphures || []).filter(a => a?.name_th?.toLowerCase().includes(text));
  }

  /**
   * Returns the filtered list of tambons for custom select dropdown based on search query.
   */
  get filteredTambonOptions() {
    const text = (this.tambonSearchText || '').trim().toLowerCase();
    if (!text) return this.filteredTambons || [];
    return (this.filteredTambons || []).filter(t => t?.name_th?.toLowerCase().includes(text));
  }

  /**
   * Returns the average payment amount in the filtered list.
   */
  get averageAmount(): number {
    if (this.filteredPaymentHistory.length === 0) return 0;
    return Math.round(this.totalAmount / this.filteredPaymentHistory.length);
  }

  /**
   * Returns the count of unique sites visited in the filtered list.
   */
  get uniqueSitesCount(): number {
    const sites = this.filteredPaymentHistory.map(item => item.siteId);
    return new Set(sites).size;
  }

  /**
   * Returns a list of unique site names from the fetched history.
   */
  get siteOptions(): string[] {
    const sites = this.payment_history?.map(item => item.siteName) || [];
    return Array.from(new Set(sites)).filter(Boolean);
  }

  /**
   * Returns filtered site options matching the autocomplete input text.
   */
  get filteredSiteOptions(): string[] {
    const q = (this.searchFieldText || '').toLowerCase().trim();
    if (!q) {
      return this.siteOptions;
    }
    return this.siteOptions.filter(site => site.toLowerCase().includes(q));
  }

  /**
   * Returns a list of unique fee type names (payment types) from the fetched history.
   */
  get feeTypeOptions(): string[] {
    const types = this.payment_history?.map(item => item.feeTypeName) || [];
    return Array.from(new Set(types)).filter(Boolean);
  }

  constructor(
    private cookieService: CookieService,
    private apiMemberService: ApiMemberService,
    private apiPaymentService : ApiPaymentService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private router: Router,
    private http: HttpClient,
    private paymentService: PaymentHistoryService,
    private languageService: LanguageService,
  ) {
    this.sub = this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
    this.routeSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // ถ้าไปหน้าอื่นที่ไม่ใช่ receipt-page ให้ล้างข้อมูล
        if (!event.url.includes('/receipt-page')) {
          this.paymentService.historyList = [];
          this.paymentService.startDate = '';
          this.paymentService.endDate = '';
        }
      }
    });
  }
  ngOnInit() {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    this.today = moment().startOf('day').toDate();
    this.minStartDate = moment().subtract(3, 'months').startOf('day').toDate();

    // 🟢 ตั้งค่า default ของ startDate และ endDate

    if (this.paymentService.historyList.length > 0) {
      console.log('paymentService data');
      // ถ้ามีข้อมูลเก่า แสดงเลย ไม่โหลดซ้ำ
      this.payment_history = this.paymentService.historyList;
      this.startDate = this.paymentService.startDate
        ? moment(this.paymentService.startDate, 'YYYY-MM-DD')
        : null;
      this.endDate = this.paymentService.endDate
        ? moment(this.paymentService.endDate, 'YYYY-MM-DD')
        : null;
    } else {
      this.startDate = moment().subtract(1, 'days').startOf('day');
      this.endDate = moment().startOf('day');
      setTimeout(() => {
        this.searchPaymentHistory();
      }, 500);
    }
    setTimeout(() => {
      forkJoin({
        tambons: this.http.get<any[]>('json/thai_tambons.json'),
        amphures: this.http.get<any[]>('json/thai_amphures.json'),
        provinces: this.http.get<any[]>('json/thai_provinces.json'),
      }).subscribe({
        next: (response) => {
          this.tambons = response.tambons;
          this.amphures = response.amphures;
          this.provincess = response.provinces;

          setTimeout(() => {
            this.getApiAddressAll();
          }, 100);
        },
        error: (err) => {
          console.error('โหลดข้อมูลล้มเหลว', err);
        },
      });
    }, 1000);
  }

  ngOnDestroy(): void {
    // cleanup subscription
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  /*#################################################### Function ################################################*/

  /**
   * Toggles the visibility of the statistics dashboard.
   */
  toggleDashboard() {
    this.showDashboard = !this.showDashboard;
  }

  /**
   * Toggles the visibility of the advanced table filter panel.
   */
  toggleFilters() {
    this.showTableFilters = !this.showTableFilters;
  }

  /**
   * Toggles the detail view display of a specific payment history card.
   */
  openDetails(receiptId: string) {
    if (this.statusOpenDetails === receiptId) {
      this.statusOpenDetails = '';
    } else {
      this.statusOpenDetails = receiptId;
    }
  }

  /**
   * Selects a site in the custom searchable combo box.
   */
  selectSite(site: string) {
    this.selectedSite = site;
    this.searchFieldText = site;
    this.isSiteDropdownOpen = false;
  }

  /**
   * Validates and closes autocomplete dropdowns, reverting to the last valid value if needed.
   */
  closeDropdowns() {
    setTimeout(() => {
      this.isSiteDropdownOpen = false;

      const options = this.siteOptions || [];
      const matched = options.find(
        site => site.toLowerCase() === (this.searchFieldText || '').toLowerCase().trim()
      );

      if (matched) {
        this.selectedSite = matched;
        this.searchFieldText = matched;
      } else if (!this.searchFieldText || this.searchFieldText.trim() === '') {
        this.selectedSite = '';
        this.searchFieldText = '';
      } else {
        this.searchFieldText = this.selectedSite || '';
      }
    }, 250);
  }

  /**
   * Selects or toggles the payment type filter.
   */
  selectFeeType(type: string) {
    if (this.selectedFeeType === type) {
      this.selectedFeeType = '';
    } else {
      this.selectedFeeType = type;
    }
  }

  /**
   * Handles click action to view a receipt, setting the active payment object first.
   */
  openReceipt(payment: PaymentHistory) {
    this.selectedPayment = payment;
    this.clickToReceipt();
  }

  /**
   * Handles click action to request a full tax invoice, setting the active payment object first.
   */
  openTaxFull(payment: PaymentHistory) {
    this.selectedPayment = payment;
    if (payment.full_tax == '3') {
      this.disabledFulltax = true;
    } else {
      this.disabledFulltax = false;
    }
    this.requestTaxFull();
  }
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text);
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text);
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text);
  }

  /*#################################################### Function ################################################*/

  /**
   * Opens custom dropdown for location selection.
   */
  openDropdown(type: 'province' | 'amphure' | 'tambon') {
    this.activeDropdown = type;
  }

  /**
   * Closes custom dropdown with delay for selection click.
   */
  closeDropdown(type: 'province' | 'amphure' | 'tambon') {
    setTimeout(() => {
      if (this.activeDropdown === type) {
        this.activeDropdown = null;
      }
      this.validateAndRevertText(type);
    }, 200);
  }

  /**
   * Validates custom search input and reverts if text does not match valid option.
   */
  validateAndRevertText(type: 'province' | 'amphure' | 'tambon') {
    if (type === 'province') {
      const match = (this.provincess || []).find(p => p?.name_th === this.provinceSearchText);
      if (match) {
        this.selectedProvinceId = match.id;
        this.province_name = match.name_th;
      } else {
        this.provinceSearchText = this.province_name || '';
      }
    } else if (type === 'amphure') {
      const match = (this.filteredAmphures || []).find(a => a?.name_th === this.amphureSearchText);
      if (match) {
        this.selectedAmphureId = match.id;
        this.amphure_name = match.name_th;
      } else {
        this.amphureSearchText = this.amphure_name || '';
      }
    } else if (type === 'tambon') {
      const match = (this.filteredTambons || []).find(t => t?.name_th === this.tambonSearchText);
      if (match) {
        this.selectedTambonId = match.id;
        this.tambon_name = match.name_th;
      } else {
        this.tambonSearchText = this.tambon_name || '';
      }
    }
  }

  /**
   * Selects province option from custom dropdown.
   */
  selectProvinceOption(province: any) {
    this.selectedProvinceId = province.id;
    this.province_name = province.name_th;
    this.provinceSearchText = province.name_th;
    this.activeDropdown = null;
    this.onProvinceChange();
    this.amphureSearchText = '';
    this.tambonSearchText = '';
  }

  /**
   * Selects amphure option from custom dropdown.
   */
  selectAmphureOption(amphure: any) {
    this.selectedAmphureId = amphure.id;
    this.amphure_name = amphure.name_th;
    this.amphureSearchText = amphure.name_th;
    this.activeDropdown = null;
    this.onAmphureChange();
    this.tambonSearchText = '';
  }

  /**
   * Selects tambon option from custom dropdown.
   */
  selectTambonOption(tambon: any) {
    this.selectedTambonId = tambon.id;
    this.tambon_name = tambon.name_th;
    this.tambonSearchText = tambon.name_th;
    this.activeDropdown = null;
    this.onTambonsChange();
  }

  openModal_option(payment: PaymentHistory) {
    this.selectedPayment = payment;
    console.log(this.selectedPayment);
    if (this.selectedPayment.full_tax == '3') {
      console.log('disabledFulltax', 'ขอแล้ว');
      this.disabledFulltax = true;
    } else {
      console.log('disabledFulltax', 'ยังไม่ขอ');
      this.disabledFulltax = false;
    }

    this.showModal_option = true;
  }
  closeModal_option() {
    this.showModal_option = false;
  }

  getApiAddressAll() {
    this.address_id = 0;
    this.apiMemberService.getMyAddress(this.token, this.uid).subscribe({
      next: (response: MyAddressAllResponse[]) => {
        this.addressListAll = response;
        this.selectedAddress = null;
        if (this.addressListAll.length > 0) {
          this.showSelectAddress = true;

          const type = 1; // แปลงเป็น number
          this.filteredAddressList = this.addressListAll.filter(
            (item) => item.address_user_type === type,
          );
          this.selectedAddress = this.filteredAddressList[0];
          this.setValueAddress();
        } else {
          this.showSelectAddress = false;
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }

  filterAddressByTaxType(): void {
    this.filteredAddressList = [];
    this.selectedAddress = null;
    this.address_id = 0;
    const type = parseInt(this.selectedTaxType, 10); // แปลงเป็น number
    this.filteredAddressList = this.addressListAll.filter(
      (item) => item.address_user_type === type,
    );
    if (this.filteredAddressList.length > 0) {
      this.showSelectAddress = true;
      this.selectedAddress = this.filteredAddressList[0];
      this.setValueAddress();
    } else {
      this.showSelectAddress = false;
      this.selectedAddress = null;
      this.setValueAddress();
    }
  }

  requestTax() {
    const detectTaxId = (value: string): boolean => {
      return /^\d+$/.test(value) && !isNaN(Number(value));
    };
    if (!this.taxName.trim()) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุชื่อผู้เสียภาษี'
          : 'Please enter the full name of the taxpayer',
      );
    } else if (
      !this.branchName.trim() &&
      !this.branchNo.trim() &&
      !this.mainOffice &&
      this.selectedTaxType === '2'
    ) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุสาขาและรหัสสาขา'
          : 'Please enter the branch code',
      );
    }
    // else if (!this.tax_phone.trim()) {
    //   this.showWarning(
    //     this.currentLang === 'TH'
    //       ? 'กรุณาระบุเบอร์โทรศัพท์ในใบกำกับภาษี'
    //       : 'Phone number is required for issuing the tax invoice.'
    //   );
    // }
    else if (!this.taxId.trim()) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุเลขประจำตัวผู้เสียภาษี'
          : 'Please enter a valid taxpayer identification number.',
      );
    } else if (!detectTaxId(this.taxId) || this.taxId.length !== 13) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาตรวจสอบเลขประจำตัวผู้เสียภาษีให้ถูกต้อง'
          : 'Please check the taxpayer identification number.',
      );
    } else if (!this.address.trim()) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุที่อยู่'
          : 'Please enter a valid address.',
      );
    } else if (this.selectedProvinceId === null) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุจังหวัด'
          : 'Please select a province.',
      );
    } else if (this.selectedAmphureId === null) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุอำเภอ'
          : 'Please select a district.',
      );
    } else if (this.selectedTambonId === null) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุตำบล'
          : 'Please select a sub district.',
      );
    } else if (!this.zipcode) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุรหัสไปรษณีย์'
          : 'Please enter a postal code',
      );
    } else {
      // this.showTaxModal = false;
      this.showModal_confirm = true;
      this.sendRequestFullTax();
    }
  }
  closeTaxModal() {
    this.showTaxModal = false;
  }
  openAddressModal() {
    this.showAddressModal = true;
  }

  onProvinceChange() {
    // console.log(this.selectedProvinceId);
    this.selectedAmphureId = null;
    this.selectedTambonId = null;
    this.zipcode = '';
    this.amphure_name = '';
    this.amphureSearchText = '';
    this.tambon_name = '';
    this.tambonSearchText = '';
    this.filteredAmphures =
      (this.selectedProvinceId ?? null) !== null
        ? this.amphures.filter(
            (a) => a.province_id === +this.selectedProvinceId!,
          )
        : [];
    if (this.provincess.length && this.selectedProvinceId) {
      const province = this.provincess.find(
        (a) => a.id === Number(this.selectedProvinceId),
      );
      this.province_name = province ? province.name_th : '';
      this.provinceSearchText = this.province_name || '';
      // console.log('✅ province_name:', this.province_name);
    } else {
      console.warn('⚠️ province list or selectedProvinceId not ready');
    }

    this.filteredTambons = []; // reset
  }

  onAmphureChange() {
    this.selectedTambonId = null;
    this.zipcode = '';
    this.tambon_name = '';
    this.tambonSearchText = '';
    this.filteredTambons =
      (this.selectedAmphureId ?? null) !== null
        ? this.tambons.filter((a) => a.amphure_id === +this.selectedAmphureId!)
        : [];
    if (this.amphures.length && this.selectedAmphureId) {
      const amphure = this.amphures.find(
        (a) => a.id === Number(this.selectedAmphureId),
      );
      this.amphure_name = amphure ? amphure.name_th : '';
      this.amphureSearchText = this.amphure_name || '';
      // console.log('✅ amphure_name:', this.amphure_name);
    }
  }

  onTambonsChange() {
    // console.log(this.selectedTambonId);
    this.zipcode = '';
    this.zipcode =
      (this.selectedTambonId ?? null) !== null
        ? this.tambons.filter((t) => t.id === +this.selectedTambonId!)[0]
            ?.zip_code || ''
        : '';

    if (this.tambons.length && this.selectedTambonId) {
      const tambon = this.tambons.find(
        (a) => a.id === Number(this.selectedTambonId),
      );
      this.tambon_name = tambon ? tambon.name_th : '';
      this.tambonSearchText = this.tambon_name || '';
      // console.log(this.tambon_name);
    }
  }

  setValueAddress() {
    if (this.selectedAddress) {
      this.address_id = this.selectedAddress.id;
      this.mainOffice = this.selectedAddress.headquarters;
      this.taxName = this.selectedAddress.name;
      this.tax_phone = this.selectedAddress.phone;
      this.email = this.selectedAddress.email;
      this.branchName = this.selectedAddress.branch;
      this.branchNo = this.selectedAddress.branch_no;
      this.taxId = this.selectedAddress.tax_id;
      this.address = this.selectedAddress.address;

      const selectedProvName = this.selectedAddress?.provinces?.trim() ?? '';
      const matchedProvince = this.provincess.find(
        (p) => p.name_th.trim() === selectedProvName,
      );
      if (matchedProvince) {
        this.selectedProvinceId = matchedProvince.id;
        this.province_name = selectedProvName;
        this.provinceSearchText = selectedProvName;
      } else {
        this.selectedProvinceId = null;
        this.province_name = '';
        this.provinceSearchText = '';
      }

      if (this.selectedProvinceId != null) {
        const provinceId = this.selectedProvinceId;
        this.filteredAmphures = this.amphures.filter(
          (a) => a.province_id === +provinceId,
        );

        const selectedAmphureName =
          this.selectedAddress?.district?.trim() ?? '';
        const matchedAmphure = this.filteredAmphures.find(
          (a) => a.name_th.trim() === selectedAmphureName,
        );
        if (matchedAmphure) {
          this.selectedAmphureId = matchedAmphure.id;
          this.amphure_name = selectedAmphureName;
          this.amphureSearchText = selectedAmphureName;
        } else {
          this.selectedAmphureId = null;
          this.amphure_name = '';
          this.amphureSearchText = '';
        }
      } else {
        this.filteredAmphures = [];
        this.selectedAmphureId = null;
        this.amphure_name = '';
        this.amphureSearchText = '';
      }

      if (this.selectedAmphureId != null) {
        const amphureId = this.selectedAmphureId;

        // กรองตำบลในอำเภอที่เลือก
        this.filteredTambons = this.tambons.filter(
          (a) => a.amphure_id === +amphureId,
        );

        // ดึงชื่อจากที่อยู่
        const selectedTambonName =
          this.selectedAddress?.sub_district?.trim() ?? '';

        // หาใน list ว่าตรงกับตำบลไหน
        const matchedTambon = this.filteredTambons.find(
          (a) => a.name_th.trim() === selectedTambonName,
        );

        if (matchedTambon) {
          this.selectedTambonId = matchedTambon.id;
          this.tambon_name = selectedTambonName;
          this.tambonSearchText = selectedTambonName;
          this.zipcode = this.selectedAddress.zip_code;
        } else {
          this.selectedTambonId = null;
          this.tambon_name = '';
          this.tambonSearchText = '';
          this.zipcode = '';
        }
      } else {
        this.filteredTambons = [];
        this.selectedTambonId = null;
        this.tambon_name = '';
        this.tambonSearchText = '';
      }
    } else {
      // ✅ ล้างค่าเมื่อไม่มี selectedAddress
      this.address_id = 0;
      this.mainOffice = false;
      this.taxName = '';
      this.tax_phone = '';
      this.email = '';
      this.branchName = '';
      this.branchNo = '';
      this.taxId = '';
      this.address = '';
      this.zipcode = '';
      this.selectedProvinceId = null;
      this.province_name = '';
      this.provinceSearchText = '';
      this.filteredAmphures = [];
      this.selectedAmphureId = null;
      this.amphure_name = '';
      this.amphureSearchText = '';
      this.filteredTambons = [];
      this.selectedTambonId = null;
      this.tambon_name = '';
      this.tambonSearchText = '';
    }
  }

  clickToReceipt() {
    this.showModal_option = false;
    this.router.navigate(['/receipt-page'], {
      state: {
        selectedPayment: this.selectedPayment,
      },
    });
  }

  sendRequestFullTax() {
    this.showTaxModal = false;
    this.showModal_confirm = false;
    const payload: RequestFullTaxPayload = {
      uid: this.uid,
      job_no: this.selectedPayment?.jobNo || '',
      full_tax: true,
      address_id: this.address_id,
      full_name: this.taxName,
      address_user_type: parseInt(this.selectedTaxType || '0', 10),
      address: this.address,
      sub_district: this.tambon_name || '',
      district: this.amphure_name || '',
      provinces: this.province_name || '',
      zip_code: this.zipcode,
      email: this.email,
      branch: this.branchName,
      branch_no: this.branchNo,
      headquarters: this.mainOffice,
      is_default: true,
      taxId: this.taxId,
      register_member_type: 0,
      subscription_id: this.selectedPayment?.subscription_id || 0,
      phone: this.tax_phone,
      request_type: this.selectedPayment?.type || 0,
    };
    // console.log(payload)
    console.log(JSON.stringify(payload).toString());

    if (payload) {
      this.isSaveLoading = true;
      this.apiMemberService.RequestTaxFull(payload, this.token).subscribe({
        next: (res: StatusAPIResponseMain) => {
          console.log('📦 Response:', res);
          if (res.code == '000') {
            this.isSaveLoading = false;
            this.showSuccess(
              this.currentLang === 'TH'
                ? 'ออกใบกำกับภาษีเต็มรูปเรียบร้อย'
                : 'Full tax invoice issued successfully.',
            );
            setTimeout(() => {
              this.searchPaymentHistory();
            }, 0);
          } else {
            this.showError(res.message);
          }
        },
        error: (err) => {
          console.log('📦 Error:', err);
          this.showError(
            'Serverส่งข้อมูลผิดพลาด ขอใบกำกับภาษีเต็มรูปไม่สำเร็จ',
          );
          this.isSaveLoading = false;
        },
        complete: () => {
          this.isSaveLoading = false;
        },
      });
    }
  }
  goHome() {
    this.router.navigate(['/home']);
  }

  closeModal_Confirm() {
    this.showModal_confirm = false;
  }

  clickToRequest() {}

  requestTaxFull() {
    this.showModal_option = false;
    this.showTaxModal = true;
    //
  }
  selectAddress(item: any) {
    this.selectedAddress = item;
    this.showAddressModal = false;
    this.setValueAddress();
  }
  goback() {
    this.router.navigate(['/home']);
  }

  /*############################################# API #################################################*/
  searchPaymentHistory() {
    if (!this.startDate || !this.endDate) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'กรุณาระบุวันที่ค้นหาก่อน'
          : 'Please specify the search date first.',
      );
    } else if (moment(this.startDate).isAfter(moment(this.endDate), 'day')) {
      this.showWarning(
        this.currentLang === 'TH'
          ? 'วันที่เริ่มต้นต้องน้อยกว่าวันที่สิ้นสุด'
          : 'Start date must be less than the end date',
      );
    } else {
      this.isLoading = true;
      const start = moment(this.startDate).startOf('day').toDate();
      const end = moment(this.endDate).startOf('day').toDate();
      this.apiPaymentService
        .getPaymentHistory(this.token, this.uid, start, end)
        .subscribe({
          next: (payment) => {
            console.log('payment data : ', payment);
            this.payment_history = payment;
            this.paymentService.historyList = payment;
            this.paymentService.startDate = moment(this.startDate).format(
              'YYYY-MM-DD',
            );
            this.paymentService.endDate = moment(this.endDate).format(
              'YYYY-MM-DD',
            );
            this.isLoading = false;
          },
          error: (err) => {
            this.payment_history = [];
            console.error('โหลดบัตรสมาชิกล้มเหลว', err);
            // this.showError('ไม่พบข้อมูลที่ค้นหา');
            this.isLoading = false;
          },
        });
    }
  }
}
